<template>
    <div></div>
</template>

<script>
export default {
    name: "Users",
    mounted() {
        const {$store: {dispatch}} = this;
        dispatch(`admin_getUsers`);
    }
}
</script>

<style scoped>

</style>